module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"no_item_message":{"none":"暫無商品。","filtered":"沒有符合條件的商品。"}}}')
  delete Component.options._Ctor
}
